// extracted by mini-css-extract-plugin
export default {"root":"BlockFooter_root__iw2Cf","title":"BlockFooter_title__VNBEa","media":"BlockFooter_media__UKdnn","text":"BlockFooter_text__rD3Gc"};